var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAdd = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 30 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M16.115 4.347a1.125 1.125 0 0 0-2.24.153v9.375H4.5l-.153.01a1.125 1.125 0 0 0 .153 2.24h9.375V25.5l.01.153a1.125 1.125 0 0 0 2.24-.153v-9.375H25.5l.153-.01a1.125 1.125 0 0 0-.153-2.24h-9.375V4.5z"
})));
export default SvgAdd;